module.exports = __webpack_public_path__ + "img/analysis_revise_wrong.aab64929.svg";